import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { VscListTree } from 'react-icons/vsc';
import { RiCloseFill } from 'react-icons/ri';

import styles from './styles.module.scss';

const SidebarContentLayout = ({ sidebar, content, containerSize }) => {
  const [menuVisible, setMenuVisible] = useState(false);

  return (
    <div
      className={[
        styles.container,
        styles[containerSize],
      ].join(' ')}
    >
      <div
        className={[
          styles.sidebar,
          menuVisible ? styles.visible : '',
        ].join(' ')}
      >
        <div className={styles['sidebar-inner']}>
          {/* Hide menu icon used for mobile, hidden on > mobile */}
          <RiCloseFill
            className={styles['hide-menu']}
            onClick={() => setMenuVisible(false)}
          />
          {sidebar}
        </div>
      </div>

      <main
        className={[
          styles.body,
          menuVisible ? styles.visible : '',
        ].join(' ')}
      >
        <div className={styles['body-inner']}>
          {/* Show menu icon used for mobile, hidden on > mobile */}
          <VscListTree
            aria-haspopup
            className={styles['show-menu']}
            onClick={() => setMenuVisible(true)}
          />
          {content}
        </div>
      </main>
    </div>
  );
};

SidebarContentLayout.defaultProps = {
  sidebar: null,
  content: null,
  containerSize: 'bothStop',
};

SidebarContentLayout.propTypes = {
  sidebar: PropTypes.node,
  content: PropTypes.node,
  containerSize: PropTypes.oneOf(['bothStop', 'rightStop', 'noStop']),
};

export default SidebarContentLayout;
